<template>
  <div class="user-list">
    <v-card :loading="isLoading">
      <v-card-text>
        <v-list>
          <v-list-item
            v-for="user in users"
            :key="user.title"
            @click="() => {}"
          >
            <v-list-item-action>
              <v-icon
                left
                :color="reservationColor(user.status)">
                {{ reservationStatus(user.status) }}
              </v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title v-text="user.name"></v-list-item-title>
              <v-list-item-subtitle v-text="user.email"></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn :to="`/users/${user.id}`">
                <v-icon left color="grey lighten-1">info</v-icon>
                Détails
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import api from '@/plugins/APIWrapper';
import { reservationMixins } from '@/mixins';

export default {
  name: 'user-list',
  mixins: [reservationMixins],
  data() {
    return {
      users: [],
      isLoading: 'success',
    };
  },
  components: {},
  async mounted() {
    try {
      this.users = await api.getClients();
      this.isLoading = false;
    } catch (e) {
      console.error(e);
      this.isLoading = 'error';
    }
  },
};
</script>
